


import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab, Form, Button, Card, Image } from 'react-bootstrap';
import '../../../../assets/css/student/dashboard/Settings.css';
import StudentLayout from '../../../../layouts/student/StudentLayout';

const StudentSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [profileData, setProfileData] = useState({
    fullName: 'Jannat Ali',
    email: 'jannat@example.com',
    phone: '+92 300 1234567',
    profilePicture: 'https://via.placeholder.com/150'
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [notifications, setNotifications] = useState({
    emailNotifications: true,
    smsNotifications: true,
    caseApprovedAlerts: true,
    donationUpdates: false
  });

  const [privacy, setPrivacy] = useState({
    showProfileToNGOs: true,
    shareContactDetails: false
  });

  const [security, setSecurity] = useState({
    twoFactorAuth: true
  });

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleNotificationToggle = (key) => {
    setNotifications({ ...notifications, [key]: !notifications[key] });
  };

  const handlePrivacyToggle = (key) => {
    setPrivacy({ ...privacy, [key]: !privacy[key] });
  };

  const handleSecurityToggle = (key) => {
    setSecurity({ ...security, [key]: !security[key] });
  };

  const handleSaveProfile = (e) => {
    e.preventDefault();
    console.log('Profile saved:', profileData);
    alert('Profile updated successfully!');
  };

  const handleSavePassword = (e) => {
    e.preventDefault();
    console.log('Password changed');
    alert('Password changed successfully!');
    setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
  };

  return (
    <StudentLayout>
      <div className="ss-settings-container">
        <div className="ss-settings-header">
          <h1>Settings</h1>
          <p>Manage your account settings and preferences</p>
        </div>

        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Card className="ss-settings-card">
            <Card.Header className="ss-tabs-header">
              <Nav variant="tabs" className="ss-nav-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="profile" className="ss-nav-link">
                    <i className="ss-icon">👤</i>
                    Profile
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="notifications" className="ss-nav-link">
                    <i className="ss-icon">🔔</i>
                    Notifications
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="privacy" className="ss-nav-link">
                    <i className="ss-icon">🔒</i>
                    Privacy
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="security" className="ss-nav-link">
                    <i className="ss-icon">🛡️</i>
                    Security
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>

            <Card.Body className="ss-card-body">
              <Tab.Content>
                {/* PROFILE TAB */}
                <Tab.Pane eventKey="profile">
                  <div className="ss-tab-content">
                    <h3 className="ss-section-title">Profile Settings</h3>
                    
                    <div className="ss-profile-picture-section">
                      <Image 
                        src={profileData.profilePicture} 
                        roundedCircle 
                        className="ss-profile-img"
                      />
                      <Button variant="outline-primary" className="ss-upload-btn">
                        Upload Picture
                      </Button>
                    </div>

                    <Form onSubmit={handleSaveProfile}>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="fullName"
                              value={profileData.fullName}
                              onChange={handleProfileChange}
                              className="ss-form-input"
                              placeholder="Enter your full name"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">Email Address</Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              value={profileData.email}
                              onChange={handleProfileChange}
                              className="ss-form-input"
                              placeholder="Enter your email"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">Phone Number</Form.Label>
                            <Form.Control
                              type="tel"
                              name="phone"
                              value={profileData.phone}
                              onChange={handleProfileChange}
                              className="ss-form-input"
                              placeholder="Enter your phone number"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <div className="ss-divider"></div>

                      <h4 className="ss-subsection-title">Change Password</h4>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">Old Password</Form.Label>
                            <Form.Control
                              type="password"
                              name="oldPassword"
                              value={passwordData.oldPassword}
                              onChange={handlePasswordChange}
                              className="ss-form-input"
                              placeholder="Enter old password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">New Password</Form.Label>
                            <Form.Control
                              type="password"
                              name="newPassword"
                              value={passwordData.newPassword}
                              onChange={handlePasswordChange}
                              className="ss-form-input"
                              placeholder="Enter new password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="ss-form-label">Confirm Password</Form.Label>
                            <Form.Control
                              type="password"
                              name="confirmPassword"
                              value={passwordData.confirmPassword}
                              onChange={handlePasswordChange}
                              className="ss-form-input"
                              placeholder="Confirm new password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Button type="submit" className="ss-save-btn">
                        Save Changes
                      </Button>
                    </Form>
                  </div>
                </Tab.Pane>

                {/* NOTIFICATIONS TAB */}
                <Tab.Pane eventKey="notifications">
                  <div className="ss-tab-content">
                    <h3 className="ss-section-title">Notification Preferences</h3>
                    <p className="ss-section-desc">Choose how you want to receive notifications</p>

                    <div className="ss-toggle-list">
                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Email Notifications</h5>
                          <p>Receive updates via email</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.emailNotifications}
                          onChange={() => handleNotificationToggle('emailNotifications')}
                          className="ss-toggle-switch"
                        />
                      </div>

                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>SMS Notifications</h5>
                          <p>Receive updates via SMS</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.smsNotifications}
                          onChange={() => handleNotificationToggle('smsNotifications')}
                          className="ss-toggle-switch"
                        />
                      </div>

                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Case Approved Alerts</h5>
                          <p>Get notified when your request is approved</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.caseApprovedAlerts}
                          onChange={() => handleNotificationToggle('caseApprovedAlerts')}
                          className="ss-toggle-switch"
                        />
                      </div>

                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Donation Updates</h5>
                          <p>Receive notifications about donations</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={notifications.donationUpdates}
                          onChange={() => handleNotificationToggle('donationUpdates')}
                          className="ss-toggle-switch"
                        />
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                {/* PRIVACY TAB */}
                <Tab.Pane eventKey="privacy">
                  <div className="ss-tab-content">
                    <h3 className="ss-section-title">Privacy Settings</h3>
                    <p className="ss-section-desc">Control your privacy and data sharing</p>

                    <div className="ss-toggle-list">
                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Show Profile to NGOs</h5>
                          <p>Allow NGOs to view your profile and requests</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={privacy.showProfileToNGOs}
                          onChange={() => handlePrivacyToggle('showProfileToNGOs')}
                          className="ss-toggle-switch"
                        />
                      </div>

                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Share Contact Details</h5>
                          <p>Share your contact information with donors</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={privacy.shareContactDetails}
                          onChange={() => handlePrivacyToggle('shareContactDetails')}
                          className="ss-toggle-switch"
                        />
                      </div>
                    </div>
                  </div>
                </Tab.Pane>

                {/* SECURITY TAB */}
                <Tab.Pane eventKey="security">
                  <div className="ss-tab-content">
                    <h3 className="ss-section-title">Security Settings</h3>
                    <p className="ss-section-desc">Manage your account security</p>

                    <div className="ss-toggle-list">
                      <div className="ss-toggle-item">
                        <div className="ss-toggle-info">
                          <h5>Two-Factor Authentication</h5>
                          <p>Add an extra layer of security to your account</p>
                        </div>
                        <Form.Check
                          type="switch"
                          checked={security.twoFactorAuth}
                          onChange={() => handleSecurityToggle('twoFactorAuth')}
                          className="ss-toggle-switch"
                        />
                      </div>
                    </div>

                    <div className="ss-security-actions">
                      <Button variant="outline-primary" className="ss-action-btn">
                        📜 View Login History
                      </Button>
                      <Button variant="outline-danger" className="ss-action-btn">
                        🚪 Logout from All Devices
                      </Button>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Card>
        </Tab.Container>
      </div>
    </StudentLayout>
  );
};

export default StudentSettings;

